import { useVariantSelectionState } from '../context/VariantSelectionContext';
import { makeVariantPrice } from '../util/make-variant-price';
import type { ProductPricingTypeEnum } from 'generated/graphql';
import { variantHasPrice } from '../util/variant-has-price';

const useVariantPrice = (
    pricingType: ProductPricingTypeEnum
): ReturnType<typeof makeVariantPrice> => {
    const { selectedVariant } = useVariantSelectionState();
    const hasPrice = selectedVariant
        ? variantHasPrice(selectedVariant, pricingType)
        : false;

    return makeVariantPrice(hasPrice, selectedVariant, pricingType);
};

export default useVariantPrice;
